// removed by extract-text-webpack-plugin
module.exports = {"footer":"styles__footer___2tvn_","maker-list":"styles__maker-list___viNTk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/styles.scss
// module id = 334
// module chunks = 0